/* PabDer — Cart Drawer */
(function(){
  var drawer, scrim, trigger;
  var productCache = {}; /* handle -> Promise<productJson> */

  function $(id){ return document.getElementById(id); }

  function open(){
    refresh();
    drawer.classList.add('open');
    scrim.classList.add('open');
    document.body.style.overflow='hidden';
    drawer.setAttribute('aria-hidden','false');
  }

  function close(){
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.style.overflow='';
    drawer.setAttribute('aria-hidden','true');
  }

  /* Use PDCurrency (USD estimate) for non-PH visitors, otherwise Shopify's own money format. */
  function money(cents){
    if (window.PDCurrency && window.PDCurrency.isForeign()) {
      return window.PDCurrency.formatUsd(cents / 100);
    }
    var amount = (cents / 100).toFixed(2);
    if(window.Shopify && window.Shopify.currency && window.Shopify.currency.active){
      var sym = window.Shopify.moneyFormat || '₱{{amount}}';
      return sym.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents/100));
    }
    return '₱' + amount;
  }

  /* Cart AJAX line items don't carry compare_at_price, so look it up from the
     product's own storefront JSON (cached per handle, one fetch per unique product). */
  function getProductData(handle){
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return productCache[handle];
  }

  function buildLine(item, compareLineTotal){
    var img = item.featured_image && item.featured_image.url
      ? '<img src="'+item.featured_image.url+'&width=200" alt="'+item.product_title+'">'
      : '';
    var variantInfo = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="cd-line__meta">'+item.variant_title+'</span>' : '';
    var onSale = compareLineTotal && compareLineTotal > item.final_line_price;
    var priceHtml = money(item.final_line_price) + (onSale ? '<span class="was">'+money(compareLineTotal)+'</span>' : '');
    return '<div class="cd-line" data-key="'+item.key+'">'  +
      '<div class="cd-line__img">'+img+'</div>'  +
      '<div class="cd-line__info">'  +
        '<div class="cd-line__name">'+item.product_title+'</div>'  +
        variantInfo +
        '<div class="cd-line__bottom">'  +
          '<div class="cd-line__price'+(onSale ? ' cd-line__price--sale' : '')+'">'+priceHtml+'</div>'  +
          '<div class="cd-qty">'  +
            '<button type="button" data-key="'+item.key+'" data-delta="-1" aria-label="Remove one">&#8722;</button>'  +
            '<span>'+item.quantity+'</span>'  +
            '<button type="button" data-key="'+item.key+'" data-delta="1" aria-label="Add one">&#43;</button>'  +
          '</div>'  +
        '</div>'  +
        '<button class="cd-line__remove" type="button" data-key="'+item.key+'" data-delta="-99">Remove</button>'  +
      '</div>'  +
    '</div>';
  }

  function render(cart){
    var body = $('cdBody');
    var foot = $('cdFoot');
    var countEl = $('cdCount');
    if(!body||!foot) return;
    if(countEl) countEl.textContent = cart.item_count > 0 ? '('+cart.item_count+')' : '';
    updateBadge(cart.item_count);
    if(cart.item_count === 0){
      body.innerHTML = '<div class="cart-drawer__empty">'  +
        '<svg viewBox="0 0 24 24"><path d="M7 9h10l.8 10.6a1 1 0 0 1-1 1.1H7.2a1 1 0 0 1-1-1.1L7 9z"/><path d="M9.5 9V7a2.5 2.5 0 0 1 5 0v2"/></svg>'  +
        '<p>Your bag is empty.</p>'  +
        '<a href="/collections/women" class="btn btn-outline">Continue Shopping</a>'  +
        '</div>';
      foot.style.display='none';
      return;
    }
    var handles = [];
    cart.items.forEach(function(item){
      if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    Promise.all(handles.map(getProductData)).then(function(productsData){
      var compareByVariant = {};
      productsData.forEach(function(p){
        if (!p || !p.variants) return;
        p.variants.forEach(function(v){
          if (v.compare_at_price) compareByVariant[v.id] = v.compare_at_price;
        });
      });
      body.innerHTML = cart.items.map(function(item){
        var perUnitCompare = compareByVariant[item.variant_id];
        var lineCompareTotal = perUnitCompare ? perUnitCompare * item.quantity : null;
        return buildLine(item, lineCompareTotal);
      }).join('');
      foot.style.display='';
      var subtotalEl = $('cdSubtotal');
      if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
      var fxNote = document.querySelector('#cdFoot .pd-foreign-note');
      if (fxNote && window.PDCurrency) fxNote.hidden = !window.PDCurrency.isForeign();
    });
  }

  function setLoading(on){
    var el = $('cdLoading');
    if(el) el.classList.toggle('on',on);
  }

  function refresh(){
    setLoading(true);
    fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){render(cart);setLoading(false);})
      .catch(function(){setLoading(false);});
  }

  function updateQty(key, delta){
    setLoading(true);
    fetch('/cart.js').then(function(r){return r.json();})
      .then(function(cart){
        var item = cart.items.find(function(i){return i.key===key;});
        if(!item){setLoading(false);return;}
        var newQty = Math.max(0, item.quantity + delta);
        return fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:key,quantity:newQty})
        });
      })
      .then(function(r){return r && r.json();})
      .then(function(cart){if(cart)render(cart);setLoading(false);})
      .catch(function(){setLoading(false);});
  }

  function updateBadge(count){
    document.querySelectorAll('.cart-badge').forEach(function(b){
      b.textContent = count || '';
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function init(){
    drawer  = $('cartDrawer');
    scrim   = $('cartDrawerScrim');
    trigger = $('cartDrawerTrigger');
    if(!drawer||!scrim) return;

    if(trigger) trigger.addEventListener('click', function(e){ e.preventDefault(); open(); });
    $('cartDrawerClose') && $('cartDrawerClose').addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

    drawer.addEventListener('click', function(e){
      var btn = e.target.closest('[data-key][data-delta]');
      if(!btn) return;
      e.preventDefault();
      updateQty(btn.dataset.key, parseInt(btn.dataset.delta, 10));
    });

    document.addEventListener('submit', function(e){
      var form = e.target.closest('form[action*="/cart/add"]');
      if(!form) return;
      e.preventDefault();
      setLoading(true);
      open();
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:form.querySelector('[name=id]').value, quantity:1})
      })
      .then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
      .then(function(cart){render(cart);setLoading(false);})
      .catch(function(){setLoading(false);});
    });
  }

  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
